import PropTypes from "prop-types";
import React from "react";

import { Button } from "@/component-library/Button";
import { cn } from "@/lib/helpers/cn";
import { Text } from "@/component-library/Text";
import { TwoButtonCard } from "@/component-library/TwoButtonCard";

import "./OnDemandWelcomeEmail.styles.scss";

export function OnDemandWelcomeEmail({
  buttonLeftClick,
  buttonRightClick,
  className,
  email,
  ...props
}) {
  const buttonLeft = (
    <Button className="primary-outline apti-TwoButtonCard-button-center" onClick={buttonLeftClick}>
      Cancel
    </Button>
  );

  const buttonRight = (
    <Button className="primary apti-TwoButtonCard-button-center" onClick={buttonRightClick}>
      Yes
    </Button>
  );

  return (
    <TwoButtonCard
      buttonLeft={buttonLeft}
      buttonRight={buttonRight}
      buttonsPosition="apti-OnDemandWelcomeEmail--buttons"
      className={cn("apti-OnDemandWelcomeEmail", className)}
      {...props}
    >
      <div className="text-center">
        <Text className="apti-OnDemandWelcomeEmail--title" color="black">
          Resend welcome email to {email}?
        </Text>
      </div>
    </TwoButtonCard>
  );
}

OnDemandWelcomeEmail.propTypes = {
  buttonLeftClick: PropTypes.func,
  buttonRightClick: PropTypes.func,
  className: PropTypes.string,
  email: PropTypes.string,
};

OnDemandWelcomeEmail.defaultProps = {
  buttonLeftClick: () => {},
  buttonRightClick: () => {},
  className: undefined,
  email: "",
};
